module.exports = __webpack_public_path__ + "img/mobile_banking_kbank.7bc66074.png";